import { ETableEditAction } from "../../Utils/Enums";
import { Vocabulary } from "../../Utils/Vocabulary";
import MUIDataTableCustomStyle from "../MUIDataTableCustomStyle";
import genericStyles from "../../Styles/genericStyles.module.css";
import { AccountModel } from "../../Utils/Models";
import { useState, createContext } from "react";
import AccountForm from "./AccountForm";
import GenericModal from "../GenericModal";
import StandardActionButtons from "../StandarsActionButtons";
import { FormsIds, TablesIds } from "../../Utils/Constants";
import { endpoints } from "../../Utils/UrlEnum";
import {
  formatNumber,
  formatNumberFromString,
  isDefined,
  isString,
} from "../../Utils/Utils";

export const CRUDContext = createContext(new AccountModel());

export default function AccountsTable() {
  const [contextValue, setContextValue] = useState(new AccountModel());
  const [openForm, setOpenForm] = useState(false);
  const [triggerReload, setTriggerReload] = useState(false);

  const columns = [
    {
      label: Vocabulary.id,
      name: "_id",
      options: {
        sort: false,
        display: false,
      },
    },
    {
      label: Vocabulary.company,
      name: "name",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.value,
      name: "balance",
      options: {
        sort: false,
        customBodyRender: (value: any) => {
          if (isDefined(value))
            return (
              (isString(value)
                ? formatNumberFromString(value)
                : formatNumber(value)) +
              " " +
              Vocabulary.currency
            );
        },
      },
    },
  ];

  return (
    <div className={genericStyles.mainContainer}>
      <CRUDContext.Provider value={contextValue}>
        <MUIDataTableCustomStyle
          title={Vocabulary.accountsList}
          CRUDEndPoint={endpoints.accounts}
          columns={columns}
          onEditAction={ETableEditAction.MODAL}
          id={TablesIds.accountsTable}
          setContextValue={setContextValue}
          handleModalForm={setOpenForm}
          triggerReload={triggerReload}
          addOrEditForm={
            <GenericModal
              title={
                contextValue?._id
                  ? Vocabulary.editAccount
                  : Vocabulary.addAccount
              }
              open={openForm}
              onClose={() => setOpenForm(false)}
              actions={
                <StandardActionButtons
                  okText={contextValue?._id ? Vocabulary.save : Vocabulary.add}
                  cancelText={Vocabulary.cancel}
                  cancelAction={() => setOpenForm(false)}
                  formId={FormsIds.accountForm}
                  type="submit"
                />
              }
            >
              <AccountForm
                contextValue={contextValue}
                onClose={() => {
                  setTriggerReload(!triggerReload);
                  setOpenForm(false);
                  setContextValue(new AccountModel());
                }}
              />
            </GenericModal>
          }
        />
      </CRUDContext.Provider>
    </div>
  );
}
